import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

function AtoresNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <Link to="/">
              <img
                src="https://static.readdy.ai/image/49e3304430570b21ebb630f9a5f081b3/7b22204017c50d4f304e554e533f6383.jpeg"
                alt="AAPEQ"
                className="h-12 w-auto"
              />
            </Link>
          </div>

          <div className="hidden sm:flex items-center gap-6">
            <button
              onClick={() => navigate(-1)}
              className={`flex items-center gap-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer bg-transparent border-none ${
                isScrolled ? 'text-gray-700 hover:text-[#F05954]' : 'text-white hover:text-[#F05954]'
              }`}
            >
              <i className="ri-arrow-left-line text-base"></i>
              Voltar
            </button>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Atores+%E2%80%94+menu+superior+%E2%80%94+Quero+entrar+na+AAPEQ"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#F05954] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#d94943] transition-all shadow-md whitespace-nowrap cursor-pointer"
            >
              Entrar na AAPEQ
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="sm:hidden p-2 cursor-pointer"
          >
            <i
              className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
                isScrolled ? 'text-[#262364]' : 'text-white'
              }`}
            ></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="sm:hidden bg-white border-t border-gray-100 py-4">
            <div className="flex flex-col space-y-3 px-4">
              <button
                onClick={() => { setIsMobileMenuOpen(false); navigate(-1); }}
                className="flex items-center gap-2 text-gray-700 hover:text-[#F05954] text-sm font-medium transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
              <a
                href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Atores+%E2%80%94+menu+mobile+%E2%80%94+Quero+entrar+na+AAPEQ"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F05954] text-white px-5 py-3 rounded-full text-sm font-medium text-center hover:bg-[#d94943] transition-all cursor-pointer block"
              >
                Entrar na AAPEQ
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default function AtoresPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const trabalhado = [
    'Construção comportamental do personagem',
    'Macro e micro objetivos dramáticos',
    'Verbos de ação aplicados à cena',
    'Subtexto e verdade emocional',
    'Entendimento da ação perfeita',
    'Mapeamento energético do texto',
    'Densidade emocional e organicidade',
    'Linha interna e atmosfera emocional',
    'Estado Zero aplicado à cena',
    'Disciplina emocional para sustentar a verdade',
    'Preparação mental antes da cena',
    'Força de presença e domínio do estado interno',
    'Comunicação ativa e consciente'
  ];

  const evolucao = [
    'Verdade emocional real',
    'Presença forte e consciente',
    'Controle interno em cenas difíceis',
    'Ação clara, limpa e objetiva',
    'Leitura emocional profunda',
    'Disciplina mental para execução contínua',
    'Subtexto vivo e orgânico',
    'Potência emocional sem desgaste',
    'Capacidade de conquistar e equilibrar a audiência',
    'Foco vibratório e consistência interpretativa'
  ];

  const tecnicas = [
    { title: 'Protocolos Telepáticos Avançados', description: 'Leitura emocional profunda da cena, sincronia com elenco, percepção de intenções e ritmos — usados como técnica profissional, sem abordagem espiritual.' },
    { title: 'Capacitação Motora Efetiva', description: 'Movimentação orgânica, gestualidade limpa, ritmo corporal, prontidão e eficiência na ação física do personagem.' },
    { title: 'Verdade no Sentir', description: 'Acesso consciente ao estado emocional real, com controle, equilíbrio e entrega verdadeira — sem colapso e sem exagero.' },
    { title: 'Construção Comportamental do Personagem', description: 'Base estruturada de comportamento, emoção, intenção e ação.' },
    { title: 'Macro e Micro Objetivos de Ação', description: 'Direcionamento claro do personagem, momento a momento.' },
    { title: 'Subtexto Vivo e Autêntico', description: 'Fluxo emocional interno que sustenta a verdade cênica.' },
    { title: 'Energia como Técnica de Performance', description: 'Gestão e organização do estado interno usados como ferramenta cênica.' },
    { title: 'Leitura Emocional Profunda', description: 'Capacidade de compreender quedas, aumentos e transições emocionais — no ator e no elenco.' },
    { title: 'Presença Estrutural', description: 'Treino para atenção, verdade, foco e densidade emocional.' }
  ];

  const exigencias = [
    'Ter estudado ou estar estudando atuação / teatro',
    'Participar ou já ter participado de peças ou processos cênicos',
    'Integrar grupo teatral',
    'Ter atuado em montagens, performances ou ensaios públicos',
    'Enviar vídeo, foto, portfólio ou qualquer prova prática'
  ];

  const paraQuem = [
    'Atores profissionais',
    'Atores em formação avançada',
    'Atores de teatro',
    'Atores de cinema e TV',
    'Performers',
    'Criadores de personagens',
    'Estudantes de escolas de interpretação'
  ];

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <AtoresNavbar />

      {/* Banner */}
      <div className="relative w-full h-[260px] sm:h-[300px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/60a2399736284792f18e6faf2021b23f.jpg"
          alt="Atores — Interpretação Cênica AAPEQ"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center px-5 text-center">
          <div className="inline-block bg-[#F05954] text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            Interpretação Cênica
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-tight">
            Atores — AAPEQ
          </h1>
          <p className="text-sm sm:text-base text-white/80 mt-3 max-w-xl">
            Verdade emocional, presença, foco interno e alta performance cênica
          </p>
        </div>
      </div>

      <div className="max-w-screen-xl mx-auto">

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <p className="text-base text-gray-700 leading-relaxed mb-4">
              A formação AAPEQ para Atores é destinada a profissionais atuantes ou em formação séria, que buscam verdade cênica, força interpretativa, foco emocional e presença real em palco e câmera.
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              Aqui, o ator é treinado para atingir um nível superior de consciência, técnica, preparação emocional e precisão comportamental.
            </p>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-star-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">O Que é Trabalhado no Ator AAPEQ</h2>
            </div>
            <p className="text-base text-gray-700 mb-6">A metodologia aplicada desenvolve:</p>
            <div className="grid sm:grid-cols-2 gap-3">
              {trabalhado.map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <p className="text-base text-gray-700 font-semibold mt-6">
              É um processo para atores que buscam consistência, força e verdade cênica real.
            </p>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-fire-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">A Evolução do Ator na AAPEQ</h2>
            </div>
            <p className="text-base text-gray-700 mb-6">O ator desenvolve:</p>
            <div className="grid sm:grid-cols-2 gap-3 mb-8">
              {evolucao.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <span className="text-[#F05954] flex-shrink-0 mt-0.5">✔</span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="bg-[#262364] text-white p-5 sm:p-6 rounded-xl">
              <p className="text-base font-semibold">
                O ator AAPEQ aprende a não se perder emocionalmente — permanece presente, lúcido e verdadeiro.
              </p>
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-tools-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Técnicas Aplicadas ao Ator</h2>
            </div>
            <p className="text-base text-gray-700 mb-4">
              Cláudio SAN aplica técnicas avançadas que ampliam a verdade do ator, sua precisão emocional, sua conexão interna e sua capacidade de execução.
            </p>
            <p className="text-base text-gray-700 font-semibold mb-6">As técnicas incluem:</p>
            <div className="space-y-4">
              {tecnicas.map((tecnica, index) => (
                <div key={index} className="bg-white p-5 rounded-xl border-l-4 border-[#F05954]">
                  <h3 className="text-base font-bold text-[#262364] mb-2 flex items-start gap-2">
                    <span className="text-[#F05954] flex-shrink-0">✔</span>
                    {tecnica.title}
                  </h3>
                  <p className="text-sm text-gray-700 leading-relaxed pl-5">{tecnica.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-bookmark-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Exigências para Entrar</h2>
            </div>
            <p className="text-base text-gray-700 font-semibold mb-4">Obrigatório comprovar atuação:</p>
            <div className="space-y-3 mb-6">
              {exigencias.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="bg-[#F05954] text-white p-5 sm:p-6 rounded-xl">
              <p className="text-base font-semibold mb-1">A AAPEQ não é para iniciantes absolutos —</p>
              <p className="text-base">É para quem já atua ou está ingressando seriamente no caminho artístico.</p>
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-focus-3-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Para Quem é Este Processo</h2>
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              {paraQuem.map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 sm:py-20 px-5 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl font-black text-[#262364] mb-6">
              Quer preparar sua interpretação com técnica, verdade e presença real?
            </h2>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Atores+%E2%80%94+CTA+final+%E2%80%94+Quero+entrar+na+AAPEQ"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full sm:w-auto bg-[#F05954] text-white px-6 py-4 rounded-full text-base font-semibold hover:bg-[#262364] transition-all cursor-pointer mx-4 sm:mx-0"
            >
              Entrar na AAPEQ — Atores
            </a>
            <div className="mt-8">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-[#262364] transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
            </div>
          </div>
        </section>
      </div>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
